import React from 'react';
import { ArrowLeft } from 'lucide-react';

const ProjectHeader = ({
    companyName,
    projectCode,
    handleBack,
    projectDate,
    validUntil,
    handleDateChange
}) => {


    return (
        <>
            <div className="page-header d-print-none">
                    <div className="row align-items-center">
                        <div className="col">
                            <div className="d-flex align-items-center">
                                <div className="d-flex align-items-center">
                                    <a className="btn btn-outline-white d-none d-sm-inline-block me-3" onClick={handleBack}>
                                        <ArrowLeft className="icon icon-tabler icon-tabler-arrow-left" />
                                        Back
                                    </a>
                                    <h3 className="page-title mb-0">Edit Project</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <div className="row align-items-center">
                <div className="col-md-8 mt-3">
                    <h3 className="mb-2">{companyName}</h3>
                    <p className="text-muted">{projectCode}</p>
                </div>
                <div className="col-md-4">
                    <div className="d-flex align-items-end justify-content-end">
                        {/* ✅ PERBAIKAN: Hapus dropdown toggle karena menu tidak ada */}
                        <button className="btn btn-outline-primary" type="button">Actions</button>
                    </div>
                </div>
                <div className="col-md-12 mb-3">
                    <div className="card mt-3">
                        <div className="card-body">
                            <div className="row mb-4">
                            <div className="col-md-6">
                                    <div className="col-md-12 mb-3">
                                        <div className="form-group row">
                                            <label className="col-4 col-form-label">Project Start Date <span className="text-danger">*</span></label>
                                            <div className="col-6">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="projectDate"
                                                    value={projectDate}
                                                    onChange={handleDateChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group row">
                                            <label className="col-4 col-form-label">Project End Date <span className="text-danger">*</span></label>
                                            <div className="col-6">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="validUntil"
                                                    value={validUntil}
                                                    onChange={handleDateChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProjectHeader; 